import { useSelect } from "@wordpress/data";
import { WEATHER_STORE } from "@/store/store";
import { WeatherSelect } from "@/store/type";
import { getCurrentDateWithDay } from "@/helpers/format-date";
import { findDailyForecastById } from "@/helpers/daily-forecast-helpers";

import Skeleton from "@/components/skeletons/Skeleton";
import CardList from "@/components/forecast/card-list/CardList";

import "./style.scss";

export const App = () => {
	const { selectedDate, dayliesData, locationId, isLoading } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				locationId: store.getLocationMarine().id,
				selectedDate: store.getMarineDate().date,
				...store.getDailyMarineState(),
			};
		},
	);

	const filtredDataByID = findDailyForecastById(locationId, dayliesData);

	const dataToMap = filtredDataByID
		.map((item) => {
			const { date, day } = getCurrentDateWithDay(item.date);
			return {
				...item,
				dayWeek: date,
				day,
			};
		})
		.slice(0, 5);

	return (
		<div className="marine-card-days">
			{isLoading ? (
				<div className="card-list">
					<Skeleton
						className="card-content"
						length={8}
						height={100}
						width={150}
						borderRadius={24}
					/>
				</div>
			) : (
				<CardList selectedDate={selectedDate} type="marine" data={dataToMap} />
			)}
		</div>
	);
};

export default App;
